<template>
  <div>
    <img class="fzp" src="@/assets/img/meituan/fzp.jpg" />
    <van-list
      class="meituanContainer"
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <div class="list">
        <div class="group" v-for="(item, index) in meituanList" :key="item.id">
          <div class="title">{{ item.activityName || '——' }}</div>
          <div class="center">
            <div class="item">
              <div class="label">美团订单编号:</div>
              <div class="value">{{ item.mtOrderId }}</div>
            </div>
            <div class="item">
              <div class="label">商户订单编号:</div>
              <div class="value">{{ item.ydOrderCode }}</div>
            </div>
            <div class="item">
              <div class="label">平台:</div>
              <div class="value">{{ item.platformName }}</div>
            </div>
            <div class="item">
              <div class="label">出库时间:</div>
              <div class="value">
                {{ formatDate(item.outStorageTime) }}
              </div>
            </div>
            <div class="item" v-show="item.cardCode">
              <div class="label">卡号:</div>
              <div class="value">{{ item.cardCode }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.cardCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.cardPwd">
              <div class="label">卡密:</div>
              <div class="value">{{ item.cardPwd }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.cardPwd"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.verifyCode">
              <div class="label">验证码:</div>
              <div class="value">{{ item.verifyCode }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.verifyCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.shortUrl">
              <div class="label">短链:</div>
              <div class="value">{{ item.shortUrl }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.shortUrl"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.redeemCode">
              <div class="label">兑换码:</div>
              <div class="value">{{ item.redeemCode }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.redeemCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item">
              <div class="label">有效期至:</div>
              <div class="value">{{ formatDate(item.expireTime) }}</div>
            </div>
            <div class="item">
              <div class="label">使用规则:</div>
              <div class="showRule" @click="showRule(index)">点击展示</div>
            </div>
            <div
              class="rule"
              v-show="index === showRuleIndex"
              v-html="item.useRule"
            />
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import moment from 'moment'
import { listCodeForH5 } from '@/api/mtH5'
export default {
  name: 'mtH5Detail',
  data() {
    return {
      loading: false,
      pageNum: 0,
      pageSize: 10,
      finished: false,
      meituanList: [],
      showRuleIndex: null
    }
  },
  created() {
    // this.loadData()
  },
  methods: {
    async loadData(init) {
      try {
        if (!init) {
          this.pageNum++
        }
        this.loading = true
        const { data } = await listCodeForH5({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          param: {
            ...this.$route.query
          }
        })
        this.meituanList.push(...data.records)
        if (this.pageSize > data.records.length) {
          this.finished = true
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.finished = true
        console.log(error)
      }
    },
    showRule(val) {
      if (val === this.showRuleIndex) {
        this.showRuleIndex = null
        return
      }
      this.showRuleIndex = val
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    },
    formatDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
.fzp {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7777;
}
.meituanContainer {
  min-height: 100vh;
  // background: #ffea8e url(../../assets/img/meituan/detailbg.jpg) top center
  //   no-repeat;
  // background-size: 100% auto;
  // padding: 23px 15px 32px;
  background: #ffea8e;
  padding: 170px 15px 32px;
  box-sizing: border-box;
  .group {
    margin: 0 0 8px;
    position: relative;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 56px;
      text-align: center;
      background: url(../../assets/img/meituan/titleBg.png) top center no-repeat;
      background-size: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .center {
      padding-top: 10px;
      box-sizing: border-box;
      background: url(../../assets/img/meituan/titleCenter.png) top center
        repeat;
      background-size: 100%;
      .item {
        display: flex;
        align-items: center;
        padding: 0 20px 21px;
        font-size: 12px;
        width: 100%;
        &:last-child {
          padding-bottom: 0;
        }
        .label {
          color: #000000;
          width: 90px;
        }
        .value {
          flex: 1;
          width: 100%;
          color: #666666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .copy {
          width: 48px;
          height: 20px;
          line-height: 20px;
          background: #030001;
          border-radius: 10px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
        }
        .showRule {
          color: #033cdc;
          text-align: right;
          flex: 1;
        }
      }
      .rule {
        background: #f3f3f5;
        border-radius: 10px;
        margin: 0 14px 0 16px;
        padding: 18px 13px 14px 13px;
        font-size: 12px;
        color: #666666;
        line-height: 20px;
        :deep(img) {
          width: 100% !important;
          height: auto !important;
        }
      }
    }
    .bottom {
      height: 22px;
      background: url(../../assets/img/meituan/titleBot.png) top center repeat;
      background-size: 100%;
    }
  }
}
</style>
